import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { shopDetails } from '@pages/modal/shopdetails';
import { AppService } from '@services/app.service';
import { Subject, takeUntil, of } from 'rxjs';
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

@Component({
    selector: 'shop-product-upload',
    templateUrl: './shop-product-upload.component.html',
    styleUrls: ['./shop-product-upload.component.scss']
})
export class ShopProductUploadComponent implements OnInit {
    searchText;
    destroy$: Subject<boolean> = new Subject<boolean>();
    shopList: shopDetails[] = [];
    selectedShopId: string = "";
    productFileUpload: string = '';
    fileError: string = '';
    showShopError: boolean = false;
    selectedFile: File | null = null;
    uploading = false;

    constructor(private appService: AppService, private router: Router,
        private spinner: NgxSpinnerService, private toaster: ToastrService,) {
    }

    ngOnInit(): void {
        this.getShopDetails();

    }


    getShopDetails() {
        this.spinner.show();
        this.appService.getShopDetails()
            .pipe(takeUntil(this.destroy$))
            .subscribe((data) => {
                this.spinner.hide();
                console.log("Shop Details::", data);
                this.shopList = data;
                if (this.shopList.length === 1) {
                    this.selectedShopId = String(this.shopList[0].traderId);
                }
            },
                (error: any) => {
                    this.spinner.hide();
                    this.toaster.error("Something went wrong for get Shop Details")
                })
    }

    onShopChange() {
        this.showShopError = false;
        this.selectedFile = null;
        this.fileError = '';
    }

    onFileChange(event: any) {
        const file: File = event.target.files[0];
        this.fileError = '';

        if (file) {
            const allowedTypes = ['application/vnd.ms-excel',                // .xls
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
                'text/csv'];                                // .csv

            if (!allowedTypes.includes(file.type)) {
                this.fileError = 'Only Excel (.xls, .xlsx) or CSV files are allowed.';
                this.selectedFile = null;
            } else {
                this.selectedFile = file;
            }
        }
    }

    uploadFile() {
        this.showShopError = !this.selectedShopId;

        if (!this.selectedShopId || !this.selectedFile || this.fileError || this.uploading) {
            return;
        }
        this.spinner.show();
        const formData = new FormData();
        formData.append('file', this.selectedFile)
        console.log(formData)
        this.appService.bulkProductFileUpload(Number(this.selectedShopId), formData)
            .pipe(takeUntil(this.destroy$))
            .subscribe((data) => {
                this.spinner.hide();
                this.successAlert();
            }, (error: any) => {
                this.spinner.hide();
                this.toaster.error(error.error.msg || "Something went wrong,please try again....")
            })
    }


    successAlert() {
        Swal.fire({
            title: 'Upload Successful!',
            text: 'Your product file was uploaded successfully.',
            icon: 'success',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            allowEscapeKey: false
        }).then((result) => {
            if (result.isConfirmed) {
                this.router.navigate(['/main/my-shop-products']);
            }
        });

    }


downloadCSVTemplate(): void {
  // Define the CSV headers
  const headers = [
    'Product Name',
    'Product Description',
    'Main Category Name',
    'Sub Category Name',
    'Shop Product MRP',
    'Shop Product SRP',
    'GST',
    'Quantity Value',
    'Quantity Type',
    'Product Short Description',
    'Brand Name'
  ];

  // Create an empty row with just the headers
  const worksheetData = [headers];

  // Convert array of arrays to worksheet
  const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(worksheetData);

  // Convert the worksheet to CSV format
  const csvOutput: string = XLSX.utils.sheet_to_csv(worksheet);

  // Add UTF-8 BOM to the CSV output
  const BOM = '\uFEFF'; // UTF-8 BOM
  const csvWithBOM = BOM + csvOutput;

  // Create a Blob with the CSV data and BOM
  const blob: Blob = new Blob([csvWithBOM], { type: 'text/csv;charset=utf-8;' });

  // Trigger download using FileSaver
  FileSaver.saveAs(blob, 'Product_Template.csv');
}


}


